import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useHttpClient } from '@xemplo/http';
import { apiUrlBuilder } from '@xemplo/url-helper';
import { useAppSettings } from '@xemplo/xemplo-app-settings';

import { GP_TAG_ENDPOINTS } from './gp-tags-constants';
import { tagQueries } from './gp-tags-query-options';
import {
  CreateTagRequest,
  UpdateEntityTagsRequest,
  UseUpdateEntityTags,
} from './gp-tags-types';

/**
 * Hook to create a new tag
 */
export function useCreateTagMutation() {
  const { applicationApiUrl } = useAppSettings();
  const { client } = useHttpClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (request: CreateTagRequest) => {
      const url = apiUrlBuilder(GP_TAG_ENDPOINTS.tags, applicationApiUrl);
      const response = await client.post(url, request);
      return response.data;
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: tagQueries.all });
    },
  });
}

/**
 * Hook to update tags for an entity
 */
export function useUpdateEntityTagsMutation(props: UseUpdateEntityTags) {
  const { applicationApiUrl } = useAppSettings();
  const { client } = useHttpClient();

  return useMutation({
    mutationFn: async (request: UpdateEntityTagsRequest) => {
      const url = apiUrlBuilder(GP_TAG_ENDPOINTS.entityTags, applicationApiUrl);
      const response = await client.patch(url, request);
      return response.data;
    },
    ...props,
  });
}
